<template>
<div class="courses_page page">

	<topheader back="back">
		<template v-slot:info>
			<span>{{$t('snippity.courses')}}</span>
		</template>
	</topheader>

	<maincontent>
		<template v-slot:content>
            <courses />
		</template>
	</maincontent>

</div>
</template>

<style scoped lang="sass">

</style>

<script>

import courses from "@/components/modules/courses/index.vue";

export default {
	name: 'courses_page',
	components: {
        courses
	},

	computed: {

	},

	methods: {

	},

	mounted() {

	}
}
</script>
